export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '娱乐圈最新爆料、明星动态、影视八卦',
    icon: 'ri-movie-line',
    color: 'primary',
  },
  {
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '网红主播、短视频达人的内幕爆料',
    icon: 'ri-live-line',
    color: 'accent',
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会事件、热门话题深度扒皮',
    icon: 'ri-fire-line',
    color: 'primary',
  },
  {
    slug: 'zongyi-jumu',
    name: '综艺剧透',
    description: '综艺节目内幕、选秀黑幕、剧情剧透',
    icon: 'ri-tv-line',
    color: 'accent',
  },
  {
    slug: 'daihuo-fanchu',
    name: '带货翻车',
    description: '直播带货事故、虚假宣传曝光',
    icon: 'ri-shopping-bag-line',
    color: 'primary',
  },
  {
    slug: 'chigua-qianxian',
    name: '吃瓜前线',
    description: '第一手吃瓜资讯，热门事件实时追踪',
    icon: 'ri-chat-smile-2-line',
    color: 'accent',
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});